<script setup>
import CustomButton from "@/components/Button/Button.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<template>
  <div class="reset-container w-1/2">
    <h1 class="form-title__text responsive-title-4 font-semibold self-start">{{ t('forgotPassword') }}</h1>
    <h4 class="forgot-password__text text-md mt-6 font-light text-black/50">
      {{ t('enterEmail') }}
    </h4>
    <div class="mt-6 w-full">
      <VTextField :label="t('emailLabel')" type="email" variant="underlined"></VTextField>
    </div>
    <CustomButton size="md-large" type="black" :rounded="true" class="form-reset__btn w-[12vw] font-semibold  responsive-body-large mt-3">{{
        t('sendResetLink')
      }}
    </CustomButton>
  </div>
</template>
<style scoped>
.form-reset__btn {
  font-size: 1rem !important;
}

@media (max-width: 1538px) {
  .form-title__text {
    font-size: 1.5rem;
  }
}

@media (max-width: 1385px) {
  .reset-container {
    width: 65%;
  }
  .form-reset__btn {
    font-size: 1rem;
  }
}

@media (max-width: 1024px) {
  .reset-container {
    width: 60%;
  }
  .form-title__text {
    font-size: 1.5rem;
  }

  .forgot-password__text {
    font-size: .875rem;
  }
  .form-reset__btn {
    width: 18vw;
  }
}

@media (max-width: 768px) {
  .btn {
    font-size: 12px;
  }
  .reset-container {
    width: 80%;
  }
  .form-title__text {
    font-size: 1.25rem;
  }

  .forgot-password__text {
    font-size: .75rem;
  }
  .form-reset__btn {
    width: 100%;
    font-size: .875rem;
  }
}
</style>